export const Colors = {
  flavors: {
    background: '#f5a9ca',
    backgroundLight: '#f9dce8',
    text: '#a6269e',
    main: {
      bysantine: '#A6269E',
      steelPink: '#D531C9',
      wheat: '#F7DFB6',
      piggyPink: '#F9DCE8',
      frenchPass: '#D9F1FD',
    },
    dark: {
      midnight: '#64175F',
      darkMagenta: '#981F90',
      pullmanBrown: '#6E4A0C',
      tyrianPurple: '#691236',
      veniceBlue: '#064C70',
    },
    light: {
      strikemaster: '#BF92C0',
      fuchsiaPink: '#D897D8',
      dryWheat: '#F7E9D3',
      amour: '#F7E8EF',
      sail: '#E9F6FD',
    },
    gradients: {
      pink: {
        illusion: '#F5A9CA',
        chantilly: '#F8C2D9',
        wispPink: '#FCE2ED',
      },
      gold: {
        white: '#FFFFFF00',
        scotchMist: '#FFFCDF',
        parisDaisy: '#FFF584',
      },
      blue: {
        frenchPass: '#D9F1FD',
      }
    },
    blue: '#0d6efd',
    indigo: '#6610f2',
    purple: '#6f42c1',
    pink: '#d63384',
    red: '#dc3545',
    orange: '#fd7e14',
    yellow: '#ffc800',
    green: '#198754',
    teal: '#20c997',
    cyan: '#0dcaf0',
    white: '#fffff',
    gray: '#6c757d',
    grayDark: '#343a40',
  },
  Black: {
    900: '#23242A',
    200: '#DDE2EB',
  },
  Gray: {
    600: '#757575',
    300: '#E0E0E0',
  },
  White: '#ffffff',
  Yellow: {
    500: '#F2C94C',
    200: '#fff9e6',
    100: '#FFF4D4',
  },
  Red: { 400: '#F87171' },
}

export const Fonts = {
  Montserrat: '"Montserrat", sans-serif',
  RobotoSlab: '"Roboto Slab", sans-serif',
  Consolas: '"Consolas", sans-serif',
}

export const Shadows = {
  main: '0px 4px 28px rgba(136, 169, 200, 0.4)',
  notification: '0px 4px 14px rgba(136, 169, 200, 0.3)',
}

export const Sizes = {
  headerHeight: '140px',
}

export const Gradients = {
  pink: `linear-gradient(130deg, rgba(245,169,202,1) 0%, rgba(248,194,217,1) 44%, rgba(252,226,237,1) 100%);`,
  gold: `linear-gradient(180deg, rgba(255,255,255,0) 14%, rgba(255,252,223,1) 53%, rgba(255,245,132,1) 100%);`,
  blue: `linear-gradient(180deg,rgba(217,241,253,0.5) 33%, rgba(217,241,253,1) 100%);`
}

export const Transitions = {
  duration: '0.25s',
  all: 'all 0.25s ease',
}

export const BorderRad = {
  s: '8px',
  m: '24px',
  round: '50%',
  full: '1000px',
}
